export default __webpack_public_path__ + "static/filmShot-fbf987b0535eee557266e9cbb67bc349.jpeg";